/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { css, jsx } from '@compiled/react';
import * as colors from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import ManageButton from './manage-button';
import { SWITCHER_TAB_BUTTON_PREFIX, SWITCHER_TAB_PANEL_PREFIX } from './utils';

const wrapperStyles = css({
	boxSizing: 'border-box',
	height: '100%',
	minWidth: 0,
	flex: 1,
	// workaround for WAC global typo overrides issue
	// https://product-fabric.atlassian.net/browse/CXP-3312
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
	'img,svg': {
		marginBottom: 0,
	},
});

const standAloneStyles = css({
	overflowY: 'auto',
	width: '343px',
});

const bodyStyles = css({
	minHeight: `calc(100% - 60px)`,
});

const footerStyles = css({
	display: 'flex',
	boxSizing: 'border-box',
	margin: '0 auto',
	paddingTop: token('space.150', '12px'),
	paddingRight: token('space.150', '12px'),
	paddingBottom: token('space.150', '12px'),
	paddingLeft: token('space.150', '12px'),
	position: 'sticky',
	bottom: 0,
	alignItems: 'center',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderTop: `1px solid ${token('color.border', colors.N30A)}`,
});

type SwitcherWrapperProps = {
	children: React.ReactNode;
	activeOrgId?: string;
};

class SwitcherWrapper extends React.Component<SwitcherWrapperProps> {
	render() {
		const { children, activeOrgId } = this.props;

		const manageButton = React.Children.toArray(children).filter(
			(child) => React.isValidElement(child) && React.Children.only(child).type === ManageButton,
		);
		const items = React.Children.toArray(children).filter(
			(child) => React.isValidElement(child) && React.Children.only(child).type !== ManageButton,
		);

		const tabProps = activeOrgId
			? {
					id: `${SWITCHER_TAB_PANEL_PREFIX}-${activeOrgId}`,
					role: 'tabpanel',
					'aria-labelledby': `${SWITCHER_TAB_BUTTON_PREFIX}-${activeOrgId}`,
				}
			: {};

		return (
			<div {...tabProps} css={[wrapperStyles, standAloneStyles]}>
				<div css={bodyStyles}>{items}</div>
				{manageButton.length ? <footer css={footerStyles}>{manageButton}</footer> : null}
			</div>
		);
	}
}

export default SwitcherWrapper;
